export default "__VITE_ASSET__B6jrQV3o__"